import noop from 'lodash/noop';
import { Checkbox, CheckboxClickEventType } from '../../Checkbox/Checkbox';
import { MultiSelectOptionWrapper, OptionLabel } from './styles';

const toggleCheckbox = (event: CheckboxClickEventType) => {
  event.stopPropagation();
};

export const MultiSelectOption = (props) => {
  const { innerProps, innerRef, data, value } = props;
  const { label } = data;
  const selectedValues = props.getValue();
  const isSelected = !!selectedValues.find((item) => value === item?.value);

  return (
    <MultiSelectOptionWrapper ref={innerRef} {...innerProps} isSelected={isSelected}>
      <Checkbox checked={isSelected} onChange={noop} onClick={toggleCheckbox} />
      <OptionLabel title={label}>{label}</OptionLabel>
    </MultiSelectOptionWrapper>
  );
};
